export { captureDocumentPhoto, deleteCapturedTempFile, scanDocuments } from './nativeCamera';
